// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wp_a big_b"};